import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, Subject } from "rxjs";
import { SiTabConfig } from "../models/si-tab-config.model";
import { ISiTabConfig } from "../interfaces/si-tab-config.interface";
import { CookieService } from "ngx-cookie";
import { FilterRetentionService } from "../shared/filter-retention.service";
import { SiKeycloakConfigService } from "./si-keycloak-config.service";
declare var $;

@Injectable({
  providedIn: "root",
})
export class SiDataService {
  private baseUrl: string = "si/service";
  private release_version = "CCID-Op-Insights-5.3.48-RELEASE";
  private release_date = "2026-10-22";
  private tabList: Array<string> = [];
  private tabMapping: Array<ISiTabConfig> = [];
  private tempTabMapping: Array<ISiTabConfig> = [];
  private tabMappingForView: Array<object> = [];
  private subTabList: Array<string> = [];
  private fullTabList: Array<object> = [];
  timeURI: string = "data/getRefreshTime";
  userPreferences: any;
  selectedRoles: any;
  userGuideURI: string = `s3/ccid/userguide`;
  apiGuideURI: string = `s3/ccid/apiguide`;
  is_feedback_exists_url: string = "dbmeta/isfeedbackexists";
  isUserGuide: boolean = false;
  isApiGuide: boolean = false;
  loader: object = {
    icon: true,
    overlay: true,
  };

  private _listners = new Subject<any>();

  listen(): Observable<any> {
    return this._listners.asObservable();
  }

  filter(filterBy: any, auto_refresh: any, landing_page: any) {
    const newfilterObj = {
      timezone: filterBy.code,
      auto_refresh: auto_refresh,
      abbr: filterBy.abbr,
      landing_page: landing_page,
    };
    this._listners.next(newfilterObj);
    this.setPreferences(newfilterObj);
  }

  setPreferences(userPreferences) {
    this.userPreferences = userPreferences;
  }
  getPreferences() {
    return this.userPreferences;
  }

  /**
   * Gets date list
   * @returns date list
   */
  getDateList(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.getData(this.timeURI).subscribe({
        next: (response) => {
          if (response.length > 0) {
            response = this.getTransformedRefreshTime(response);
          }
          observer.next(response);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
          observer.complete();
        },
      });
    });
  }

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private filterRetentionService: FilterRetentionService,
    private configService: SiKeycloakConfigService
  ) {
    // this.refreshData();
    const fullTabList = [
      {
        tabId: "aggregatedReports",
        path: "aggregatedReports",
        tabName: "Aggregate",
        tabSequence: 1,
        subTabs: [
          {
            tabId: "reportsSIP",
            path: "reportsSIP",
            tabName: "SIP Interfaces",
            tabSequence: 1,
          },
          {
            tabId: "reportsREST",
            path: "reportsREST",
            tabName: "REST APIs",
            tabSequence: 2,
          },
          {
            tabId: "summaryReport",
            path: "summaryReport",
            tabName: "Summary",
            tabSequence: 3,
          },
        ],
      },
      {
        tabId: "callDetailReports",
        path: "callDetailReports",
        tabName: "Call Details",
        tabSequence: 2,
        subTabs: [
          {
            tabId: "cdr",
            path: "cdr",
            tabName: "TDRs (Error)",
            tabSequence: 1,
          },
          {
            tabId: "cdr200",
            path: "cdr200",
            tabName: "TDRs (OK High Response Time)",
            tabSequence: 2,
          },
          {
            tabId: "cdr200All",
            path: "cdr200All",
            tabName: "TDRs (OK All)",
            tabSequence: 3,
          },
          {
            tabId: "policyManager",
            path: "policymanager",
            tabName: "Policy Manager",
            tabSequence: 4,
          },
        ],
      },
      {
        tabId: "responseTimeReports",
        path: "responseTimeReports",
        tabName: "Response Times",
        tabSequence: 3,
        subTabs: [
          {
            tabId: "responseTimeSip",
            path: "responseTimeSip",
            tabName: "Response Time (SIP)",
            tabSequence: 1,
          },
          {
            tabId: "responseTimeRest",
            path: "responseTimeRest",
            tabName: "Response Time (REST)",
            tabSequence: 2,
          },
        ],
      },
      {
        tabId: "reportsException",
        path: "reportsException",
        tabName: "Exception Report",
        tabSequence: 4,
        subTabs: [],
      },
      {
        tabId: "userAdmin",
        path: "userAdmin",
        tabName: "User Management",
        tabSequence: 8,
        subTabs: [],
      },
      {
        tabId: "ecc",
        path: "ecc",
        tabName: "Spoofed Call Protection",
        tabSequence: 5,
        subTabs: [],
      },
      {
        tabId: "bcd",
        path: "bcd",
        tabName: "Branded Call Display",
        tabSequence: 6,
        subTabs: [],
      },
    ];
    this.fullTabList = fullTabList;
    fullTabList.forEach((tab) => {
      this.tabMapping.push(
        new SiTabConfig(
          tab.tabName,
          tab.tabId,
          tab.path,
          tab.tabSequence,
          tab.subTabs
        )
      );
    });
    this.tempTabMapping = this.tabMapping;
    fullTabList.forEach((tab) => {
      if (tab.subTabs.length > 0) {
        tab.subTabs.forEach((st) => {
          st.tabId = st.tabId === "cdr" ? "callDetailReport" : st.tabId;
          this.tabMappingForView.push({
            tabName: st.tabName,
            tabId: st.tabId,
            path: st.path,
            tabSequence: st.tabSequence,
          });
        });
      } else {
        this.tabMappingForView.push({
          tabName: tab.tabName,
          tabId: tab.tabId,
          path: tab.path,
          tabSequence: tab.tabSequence,
        });
      }
    });
    this.tabMappingForView.push({
      tabName: "API",
      tabId: "api",
      path: "api",
      tabSequence: 7,
    });
  }

  getReleaseVersion() {
    return this.release_version;
  }

  getReleaseDate() {
    return this.release_date;
  }

  setTabList(tabList) {
    this.selectedRoles = tabList;
    this.tabList = tabList;
  }

  getTabList() {
    return this.tabList;
  }

  getTabMapping() {
    this.tabList = [
      "aggregatedReports",
      "callDetailReports",
      "responseTimeReports",
      "ecc",
      "bcd",
      "userAdmin",
      "reportsException",
    ];

    let tabMapping = this.tabMapping.filter(
      (tab) => this.tabList.indexOf(tab.getTabId()) !== -1
    );
    const allTabs = [];
    tabMapping.forEach((d) => {
      d.subTabs = d.subTabs.filter((tab) => {
        return this.selectedRoles.includes(tab["tabId"]);
      });
    });
    tabMapping.forEach((d) => {
      if (d.subTabs.length < 1) {
        if (this.selectedRoles.includes(d.tabId)) {
          allTabs.push(d);
        }
      } else {
        allTabs.push(d);
      }
    });
    tabMapping = allTabs;
    return tabMapping.sort((a, b) => a.getTabSequence() - b.getTabSequence());
  }

  getSubTabMapping() {
    const subTabList = [];
    this.fullTabList.forEach((tabs) => {
      tabs["subTabs"].forEach((subtab) => {
        subTabList.push(subtab);
      });
    });
    this.subTabList = subTabList;
    return this.subTabList;
  }

  setActiveTab(activeTab) {
    this.cookieService.put("activeTab", activeTab);
  }

  setActiveSubTab(activeSubTab) {
    this.cookieService.put("activeSubTab", activeSubTab);
  }

  getAll() {
    return this.filterRetentionService.getAll();
  }

  setTabConfig(tabName, config) {
    return new Observable<any>((observer) => {
      this.getTabConfig(tabName).subscribe(
        (filter) => {
          // if active tab found in index DB
          if (filter) {
            const filterCopy = JSON.parse(JSON.stringify(filter));
            filterCopy.value = config;
            this.filterRetentionService.updateTabConfig(filterCopy).subscribe(
              () => {
                observer.next(filterCopy.value);
                observer.complete();
              },
              (err) => {
                observer.error(err);
                observer.complete();
              }
            );
          } else {
            this.filterRetentionService.setTabConfig(tabName, config).subscribe(
              (response) => {
                observer.next(config);
                observer.complete();
              },
              (err) => {
                observer.error(err);
                observer.complete();
              }
            );
          }
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }

  getTabConfig(tabName): Observable<any> {
    return this.filterRetentionService.getTabConfig(tabName);
  }

  deleteTabConfig(id): Observable<any> {
    return this.filterRetentionService.deleteTabConfig(id);
  }

  clearIndexedDB(): Observable<any> {
    return this.filterRetentionService.clearStore();
  }

  getActiveTab() {
    return this.cookieService.get("activeTab");
  }

  getActiveSubTab() {
    return this.cookieService.get("activeSubTab");
  }

  getData(endPoint: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/${endPoint}`);
  }
  postData(endPoint: string, data): Observable<any> {
    return this.http.post(`${this.baseUrl}/${endPoint}`, data, {
      responseType: "text",
    });
  }

  postDataJson(endPoint: string, data): Observable<any> {
    return this.http.post(`${this.baseUrl}/${endPoint}`, data, {
      responseType: "json",
    });
  }

  callHeaderLink(actionName) {
    if (actionName[1] === "userGuide") {
      this.isUserGuide = true;
      this.getUserGuideObj().subscribe((response) => {
        this.isUserGuide = false;
        window.open(response["presignedURL"], "_blank");
      });
    }
    if (actionName[1] === "goToCCIPortal") {
      window.open(
        this.configService.getConfigByKey("ccid_portal_url"),
        "_blank"
      );
    }
    if (actionName[1] === "apiGuide") {
      this.isApiGuide = true;
      this.getApiGuideObj().subscribe((response) => {
        this.isApiGuide = false;
        window.open(response["presignedURL"], "_blank");
      });
    }
    if (actionName[1] === "getFeedback") {
      $("#userfeedback").modal("show");
    }
  }

  getUserGuideObj(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.getData(this.userGuideURI).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }

  getApiGuideObj(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.getData(this.apiGuideURI).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }

  getUserFeedbackExistence(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.getData(this.is_feedback_exists_url).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }

  getTransformedRefreshTime(refreshTime) {
    return refreshTime;
  }

  formateDateMMDDYY(dateObj) {
    const day = dateObj.getDate();
    const month = Number(dateObj.getMonth()) + 1;
    const year = dateObj.getFullYear();
    return month + "-" + day + "-" + year;
  }
  formateDate(dateObj) {
    let day = dateObj.getDate();
    let month: any = Number(dateObj.getMonth()) + 1;
    const year = dateObj.getFullYear();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    return year + "-" + month + "-" + day;
  }
  getDataByParam(endPoint: string, params): Observable<any> {
    return this.http.get(`${this.baseUrl}/${endPoint}`, { params: params });
  }
}
